(function () {
  var root = document.getElementById('cc-cart');
  if (!root || window.__ccCart) return;
  window.__ccCart = true;
  if (root.parentElement !== document.body) document.body.appendChild(root);
  var sectionId = root.dataset.section;
  var invalidMsg = root.dataset.invalid || '';
  var path = window.location.pathname;

  function inner() { return root.querySelector('[data-ccd-inner]'); }
  function setLoading(on) { root.classList.toggle('is-loading', on); }
  function open() {
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('ccd-lock');
  }
  function close() {
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('ccd-lock');
  }
  function updateBubble(count) {
    document.querySelectorAll('.cart-bubble').forEach(function (b) { b.classList.toggle('visually-hidden', count < 1); });
    document.querySelectorAll('.cart-bubble__text-count').forEach(function (c) {
      c.textContent = count;
      c.classList.toggle('hidden', count < 1);
    });
  }
  function swap(html) {
    if (!html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('[data-ccd-inner]');
    if (fresh) {
      inner().replaceWith(fresh);
      updateBubble(Number(fresh.dataset.count || 0));
    }
  }
  function refresh() {
    return fetch(path + '?sections=' + encodeURIComponent(sectionId), { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (d) { swap(d[sectionId]); });
  }
  function showMsg(text) {
    var m = root.querySelector('[data-ccd-msg]');
    if (!m) return;
    m.textContent = text || '';
    m.hidden = !text;
  }
  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, data: j }; }); });
  }
  function getCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
  }
  function validCodes(cart) {
    return (cart.discount_codes || []).filter(function (d) { return d.applicable; }).map(function (d) { return d.code; });
  }
  function handle(p) {
    return p.then(function (res) {
      if (res && res.data && res.data.sections) swap(res.data.sections[sectionId]);
      else return refresh();
      return res;
    }).catch(refresh).finally(function () { setLoading(false); });
  }

  window.ccCart = {
    open: function () { open(); setLoading(true); refresh().finally(function () { setLoading(false); }); },
    close: close,
    refresh: refresh
  };

  // Add to cart: open instantly, then add and render
  window.addEventListener('submit', function (e) {
    var form = e.target;
    var action = form && form.getAttribute && (form.getAttribute('action') || '');
    if (!action || action.indexOf('/cart/add') === -1 || form.hasAttribute('data-no-cc-cart')) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    open();
    setLoading(true);
    var fd = new FormData(form);
    fd.append('sections', sectionId);
    fd.append('sections_url', path);
    fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { Accept: 'application/json' }, body: fd })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, data: j }; }); })
      .then(function (res) {
        if (res.ok && res.data.sections) { swap(res.data.sections[sectionId]); return; }
        return refresh().then(function () { if (!res.ok) showMsg(res.data.description || res.data.message); });
      })
      .catch(refresh)
      .finally(function () { setLoading(false); });
  }, true);

  // Header cart icon opens this cart instead of the theme's
  window.addEventListener('click', function (e) {
    var t = e.target.closest('[data-testid="cart-drawer-trigger"], header a[href$="/cart"], .header a[href$="/cart"]');
    if (!t || root.contains(t)) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    window.ccCart.open();
  }, true);

  // Clicks inside the cart
  root.addEventListener('click', function (e) {
    var c = e.target.closest('[data-ccd-close]');
    if (c) {
      e.preventDefault();
      close();
      return;
    }
    var q = e.target.closest('[data-ccd-qty]');
    if (q) {
      setLoading(true);
      handle(post('/cart/change.js', { line: Number(q.dataset.ccdQty), quantity: Math.max(0, Number(q.dataset.q)), sections: [sectionId], sections_url: path }));
      return;
    }
    var rm = e.target.closest('[data-ccd-rmcode]');
    if (rm) {
      setLoading(true);
      handle(getCart().then(function (cart) {
        var keep = validCodes(cart).filter(function (code) { return code.toLowerCase() !== rm.dataset.ccdRmcode.toLowerCase(); });
        return post('/cart/update.js', { discount: keep.join(','), sections: [sectionId], sections_url: path });
      }));
    }
  });

  // Discount code: apply, and if it isn't valid remove it again so it never reaches checkout
  root.addEventListener('submit', function (e) {
    var f = e.target.closest('[data-ccd-discform]');
    if (!f) return;
    e.preventDefault();
    var code = (f.elements.discount.value || '').trim();
    if (!code) return;
    setLoading(true);
    getCart().then(function (cart) {
      var codes = validCodes(cart);
      if (codes.indexOf(code) === -1) codes.push(code);
      return post('/cart/update.js', { discount: codes.join(',') });
    }).then(function (res) {
      var applied = (res && res.data && res.data.discount_codes) || [];
      var mine = applied.filter(function (d) { return d.code.toLowerCase() === code.toLowerCase(); })[0];
      if (mine && mine.applicable) return refresh();
      var keep = applied.filter(function (d) { return d.applicable; }).map(function (d) { return d.code; });
      return post('/cart/update.js', { discount: keep.join(',') }).then(refresh).then(function () { showMsg(invalidMsg); });
    }).catch(refresh).finally(function () { setLoading(false); });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && root.classList.contains('is-open')) close();
  });

  // If the theme adds something on its own, show it here too
  document.addEventListener('cart:update', function () { window.ccCart.open(); });
})();